/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';

import { Grid, Typography, makeStyles, Button } from '@material-ui/core';

import IconDvdline from '../../assets/images/ic-dvdline.svg';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles((theme) => {
  return {
    descriptionTypography: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
      margin: '12px 0 0',
      textAlign: 'left',
    },
    fieldContainer: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '80%',
      },
    },
    iconRadiology: {
      height: '30px',
      width: '30px',
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
    parentContainer: {
      maxWidth: '600px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '90%',
      },
    },
    radioContrainer: {
      textAlign: 'left',
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '11px',
      fontWeight: 'bold',
      overflowWrap: 'break-word',
    },
    title: {
      marginBottom: '0.5rem',
    },
    tooltipContainer: {
      marginLeft: '10px',
    },
    typographyChangeTitle: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontSize: '12px',
    },
    typographyDescription: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '18px',
      margin: '12px 0px 20px',
    },
    typographyRemove: {
      color: '#B12A2A',
      cursor: 'pointer',
      fontSize: '12px',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      marginLeft: '12px',
    },
    uploadActions: {
      marginTop: '4px',
    },
  };
});

export default ({ filesStatus, hideFileControls, onChangeTitle, onRemoveFiles, onFilesUpload, workspaceMainFileType, onOpenImageSelectionDialog }) => {
  const classes = useStyles();
  const [status, setstatus] = useState(filesStatus);

  const handleFileChange = (evt) => {
    const filesToUpload = [...evt.target.files];
    if (onFilesUpload && filesToUpload) onFilesUpload(filesToUpload);
    evt.target.value = null;
  };

  const handleOpenImageSelectionDialog = () => {
    if (onOpenImageSelectionDialog) onOpenImageSelectionDialog();
  };

  useEffect(() => {
    setstatus(filesStatus);
  }, [filesStatus]);

  const renderUploadField = () => {
    if (!status?.uploaded) {
      return (
        <Grid container justify="flex-start" alignItems="center">
          <Grid item>
            {workspaceMainFileType === 'dicom' ? (
              <>
                <input onChange={handleFileChange} multiple directory="" webkitdirectory="" moxdirectory="" hidden id="personalized-video-files--self-upload" type="file" />
                <label htmlFor="personalized-video-files--self-upload">
                  <Button variant="outlined" component="span" color="primary">
                    Upload Radiology Files
                  </Button>
                </label>
              </>
            ) : null}

            {workspaceMainFileType === 'any' ? (
              <label htmlFor="personalized-video-files--self-upload">
                <Button onClick={handleOpenImageSelectionDialog} variant="outlined" component="span" color="primary">
                  Upload Radiology Files
                </Button>
              </label>
            ) : null}
          </Grid>
          <Grid item>
            <div className={classes.tooltipContainer}>
              <SimpleTooltip title="Some radiology images can be very large and can take a few minutes to transfer and upload, this is normal." />
            </div>
          </Grid>
        </Grid>
      );
    }
    return (
      <div className={classes.parentContainer}>
        <Grid container className={classes.statsContainer}>
          <Grid item xs={12} md={6} style={{ padding: '4px 8px' }}>
            <Typography className={classes.statsText}>Title</Typography>
            <Typography className={classes.statsText}> {status.study} </Typography>
          </Grid>
          <Grid item xs={12} md={6} style={{ padding: '4px 8px' }}>
            <Typography className={classes.statsText}>{status?.fileType !== 'dcm' ? 'File Type' : 'Images'}</Typography>
            <Typography className={classes.statsText} style={{ color: status.imageCount > 0 ? '#388E3C' : 'B12A2A' }}>
              {status?.fileType !== 'dcm' ? status?.fileType?.toUpperCase() : `${status.imageCount} Images`}
            </Typography>
          </Grid>
        </Grid>

        {!hideFileControls && (
          <div className={classes.uploadActions}>
            <span aria-hidden="true" onClick={onChangeTitle}>
              <span className={classes.typographyChangeTitle}>Change Title</span>
            </span>
            &nbsp; | &nbsp;
            <span onClick={onRemoveFiles} className={classes.typographyRemove} aria-hidden="true">
              Remove
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="text-left" style={{ marginTop: '28px' }}>
      <Grid container justify="flex-start" alignItems="center">
        <Grid item style={{ display: 'inline-flex' }}>
          <img src={IconDvdline} className={classes.iconRadiology} alt="radiology icon" />
        </Grid>
        <Grid item>
          <Typography className={classes.typographyTitle}>
            <span style={{ color: '#E92828' }}>*</span>&nbsp;Radiology Files
          </Typography>
        </Grid>
      </Grid>

      <p className={classes.descriptionTypography}>
        These files can be obtained from your radiology site. They typically come on a CD, DVD or flash drive or are made available to you through a website portal.
      </p>

      <div style={{ marginTop: '16px' }}>{renderUploadField()}</div>
    </div>
  );
};
